// dateUtil — tiny date-math leaf module with zero dependencies.
//
// Exists so negotiationTruth.js (the canonical deal-holder resolver) and
// projectLoop.js can both use `daysSince`/`waitedLabel` without a circular
// import: negotiationTruth.js needs date math, and dealHolder.js needs
// negotiationTruth.js while projectLoop.js needs dealHolder.js — if
// negotiationTruth.js pulled `daysSince` from projectLoop.js, that loop would
// close. projectLoop.js re-exports these for every existing caller.

export function daysSince(ts) {
  if (!ts) return null
  const d = new Date(ts)
  if (isNaN(d.getTime())) return null
  return Math.max(0, Math.floor((Date.now() - d.getTime()) / 86400000))
}

// Short "· 3d" / "· 2w" suffix for how long something's been waiting.
export function waitedLabel(days) {
  if (days == null) return ''
  if (days === 0) return 'today'
  if (days < 14) return `${days}d`
  if (days < 60) return `${Math.round(days / 7)}w`
  return `${Math.round(days / 30)}mo`
}

// A date with no time ("2026-10-08", a Postgres `date` column) is a calendar
// day, not an instant. `new Date('2026-10-08')` reads it as midnight UTC,
// which in California is the evening before — every decided_on, due_date and
// invoice_date displayed a day early. displayDate reads a bare date as local
// midnight and passes anything else (timestamps, Date objects, numbers)
// straight to `new Date`, so it is safe at every display site.
const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/

export function displayDate(value) {
  if (typeof value === 'string' && DATE_ONLY.test(value)) {
    const [y, m, d] = value.split('-').map(Number)
    return new Date(y, m - 1, d)
  }
  return new Date(value)
}
